import { StyleSheet, View } from 'react-native';
import { useParams } from 'react-router-dom';
import { ProductDetail } from './productDetail';

export const Product = () => {
  const { productId = '' } = useParams();

  return (
    <View style={styles.container}>
      <ProductDetail productId={productId} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
  },
});
